import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

export const PageHeading: React.FC<EmptyProps> = () => {
	return (
		<>
			<Text className="mb-2" variant="heading" as="div" size="large">
				<Translate value="fe.pages.redirect.intro" />
			</Text>
			<Text className="mb-8" variant="heading" as="h1" size="x-large">
				<Translate value="fe.pages.redirect.heading" />
			</Text>
		</>
	);
};
